// @flow

import * as React from 'react';

type FilterParams = {|
  bg: string,
  thumbBg: string,
  sliderColor: string,
  titleColor: string,
  subTitleColor: string,
  ascColor: string,
  chipBg: string,
|};

const filterContext: React.Context<FilterParams> = React.createContext<FilterParams>(
  {
    bg: 'transparent',
    thumbBg: 'yellow',
    titleColor: 'white',
    ascColor: 'green',
    subTitleColor: 'blue',
    chipBg: 'transparent',
    sliderColor: 'red',
  },
);

export const FilterProvider = filterContext.Provider;

export const useFilterContext = (): FilterParams => {
  return React.useContext(filterContext);
};
